import React from "react";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import ru from "javascript-time-ago/locale/ru.json";
import ReactTimeAgo from "react-time-ago";
import { formatQueuedDisplay } from "../../utils/queuedTimeDisplay";

TimeAgo.addDefaultLocale(en);
TimeAgo.addLocale(ru);

const LastSeen = ({ record }) => {
  const timeInQueue = record?.TimeInQueue;
  const [now, setNow] = React.useState(() => Date.now());

  // Re-evaluate masking every second so we switch to hh:mm at 1 minute
  // instead of letting ReactTimeAgo continue as "1 minute ago", "2 minutes ago".
  React.useEffect(() => {
    if (!timeInQueue) return undefined;

    const intervalId = window.setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [timeInQueue]);

  const date = timeInQueue ? new Date(timeInQueue) : null;
  const display =
    date instanceof Date && !Number.isNaN(date.getTime())
      ? formatQueuedDisplay(date, now)
      : null;

  if (!display) {
    return <div>--</div>;
  }

  if (display.mode === "hhmm") {
    return <div>{display.text}</div>;
  }

  return (
    <div>
      <ReactTimeAgo date={date as Date} locale="en-US" timeStyle="round" />
    </div>
  );
};

export default LastSeen;
